import React, {Component, PureComponent} from "react";
import _ from "lodash";
import FactorTypes from "../../../constants/FactorTypes";
import Factor from "./Factor";

class EventDop extends Component {
	dopKeys = {
		0 : {0 : true},
		1 : {4 : true, 8 : true},
		2 : {5 : true},
		3 : {3 : true}
	};

	render() {
		const {factors, activeTab, type} = this.props;
		const maxColumnInRow = 10;

		let i = 0;
		let fType = 0;

		return Object.entries(factors).map(([key, value]) => {
			const sorted = Object.keys(value).sort();

			const group = sorted.map((typeName) => {
				const points = value[typeName];
				const header = <td><strong>{typeName}:</strong></td>;
				let isHeader = true;

				const pointsKeys = Object.keys(points).sort();
				return pointsKeys.map(point => {
					const items = points[point];

					const cols = [];

					if ( +key === 1000000 ) {
						// const pairPt = item.factor.pt * -1;
						// const pairItems = points[pairPt];
						const nPoints = Object.assign({}, points);
						const itemsFirst = nPoints[1];
						const itemsSecond = nPoints[2];

						let prevPt = 0;

						const rows = Object.keys(itemsFirst).map((pt) => {
							const itemFirst = itemsFirst[pt];
							const itemSecond = itemsSecond.hasOwnProperty(pt * -1) ? itemsSecond[pt * -1] : false;


							itemFirst.map((item) => {
								cols.push(<td key={i++}>{item.factor.pt}</td>);
								cols.push(<td key={i++}>{item.text}</td>);
								cols.push(<td key={i++}><Factor item={item.factor} type={type}/></td>);
							});

							if ( itemSecond !== false ) {
								itemSecond.map((item) => {
									cols.push(<td key={i++}>{item.factor.pt}</td>);
									cols.push(<td key={i++}>{item.text}</td>);
									cols.push(<td key={i++}><Factor item={item.factor} type={type}/></td>);
								});
							}

							return (<tr>
								{cols}
							</tr>);
						});

						return rows;
					}
					else {
						let prevTeam = '';

						if ( point !== 'no-point' ) {
							cols.push(<td key={`point_${point}`}><strong>({point})</strong></td>);
						}

						const sortedItems = _.sortBy(items, item => item.factor.i);
						const sortedItemsCount = sortedItems.length;

						sortedItems.forEach((item) => {
							fType = item.factor.t;

							if ( item.isIndividual && item.team !== prevTeam ) {
								cols.push(<td key={item.team}><strong>{item.team}</strong></td>);
								prevTeam = item.team;
							}

							const factorElement = <Factor item={item.factor} type={type}/>;

							if ( sortedItemsCount > maxColumnInRow ) {
								cols.push(<div><span>{item.text}</span>{factorElement}</div>);
							}
							else {
								cols.push(<td key={i++}>{item.text}</td>);
								cols.push(<td key={i++}>{factorElement}</td>);
							}
						});

						return (
							<tr key={`row_${i++}`}>
								{isHeader ? header : <td>&nbsp;</td>}

								{fType === FactorTypes.F_SCORES ? <td className="inline">{cols}</td> : cols}
							</tr>
						);
					}
				});
			});

			return (
				<div key={`tab_${i++}`} className={`tabs__tab ${(fType in this.dopKeys[activeTab] || activeTab === 0) && 'show'}`}>
					<div className="additional">
						<table>
							<tbody>
								{group}
							</tbody>
						</table>
					</div>
				</div>
			);
		});
	}
}

export default EventDop;


// WEBPACK FOOTER //
// ./src/app/components/EventById/Event/EventDop.js